import EmblaCarousel from 'embla-carousel'
import tinytabs from '@knadh/tinytabs';
const form = document.querySelector('.lookup form')
const wrap = document.querySelector('.lookup .wrap')
const recaptchaKey = '6LfnCMstAAAAADInQBKKZ2SutC3WBG38vZ92CAKF';

const submitEndpoint = 'https://us-central1-az-candidate-lookup26.cloudfunctions.net/lookup'

export const updateSelectedSnapDisplay = (emblaApi, snapDisplay) => {
  const updateSnapDisplay = (emblaApi) => {
    const selectedSnap = emblaApi.selectedScrollSnap()
    const snapCount = emblaApi.scrollSnapList().length
    snapDisplay.innerHTML = `${selectedSnap + 1} / ${snapCount}`
  }

  emblaApi.on('select', updateSnapDisplay).on('reInit', updateSnapDisplay)

  updateSnapDisplay(emblaApi)
}

form.addEventListener('submit', async e => {
    e.preventDefault()
    wrap.setAttribute('aria-busy', 'true')
    form.querySelector('button').setAttribute('disabled', 'disabled')
    wrap.style.minHeight = `${wrap.offsetHeight}px`

    const checkURL = new URL('check.svg', import.meta.url)
    const warnURL = new URL('warning.svg', import.meta.url)

    // await grecaptcha.ready(async () => {
        // const token = await grecaptcha.execute(recaptchaKey, { action: 'submit' })
        const data = new FormData(form)
        // data.set('_token', token)

        const resp = await fetch(submitEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(data).toString()
        })
        const body = await resp.json()

        console.log(body)

        if (!body || !body.candidates || body.candidates.length === 0 || body.error) {
            wrap.innerHTML = `
                <p class="no-results">For more information about how to vote this cycle, please visit <a href="https://iwillvote.com/il">IWillVote.com</a></p>`
        } else {
            document.querySelector('#findYourDistrict').remove()
            wrap.innerHTML = ''

            if (body.partial) {
                wrap.innerHTML = '<p class="message">We couldn\'t find an exact match for your address, but these districts and locations are near you.</p>'
            }

            if (!body.iwv.error_code)
            {

                const voting_methods = [
                    {'title':'Early Vote','key':'early_vote_locations'},
                    {'title':'Vote by Mail','key':'drop_off_locations'},
                    {'title':'Election Day','key':'polling_locations'},
                ]

                const howToVote = document.createElement('div')


                const howToVoteTitle = document.createElement('h2')
                howToVoteTitle.innerText = 'How to Vote'
                howToVote.appendChild(howToVoteTitle)

                const voteMethods = document.createElement('div')
                voteMethods.classList.add('tabs')
                howToVote.appendChild(voteMethods)


                for(const v in voting_methods){
                    const iwvMethod = voting_methods[v]
                    if(body.iwv[iwvMethod.key]){
                        const method = document.createElement('section')
                        method.classList.add('tab-section')
                        method.id = iwvMethod.key
                        method.setAttribute('data-name',iwvMethod.title)
                        const methodTitle = document.createElement('h3')
                        methodTitle.innerText = iwvMethod.title
                        method.appendChild(methodTitle)

                        const pollingLocation = document.createElement('div')
                        pollingLocation.classList.add('embla','section')
                        const embla = document.createElement('div')
                        pollingLocation.appendChild(embla)
                        embla.classList.add('embla__viewport')
                        const list = document.createElement('ul')
                        embla.appendChild(list)
                        list.classList.add('embla__container')

                        const controls = document.createElement('div')
                        pollingLocation.appendChild(controls)
                        controls.classList.add('embla__controls')

                        const prev = document.createElement('button')
                        prev.classList.add('embla__prev')
                        prev.innerHTML = '&larr;'

                        const next = document.createElement('button')
                        next.classList.add('embla__next')
                        next.innerHTML = '&rarr;'

                        const snapDisplay = document.createElement('div')
                        snapDisplay.classList.add('embla__selected-snap-display')
                        snapDisplay.innerHTML = '1 / 0'

                        controls.append(prev)
                        controls.append(next)
                        controls.appendChild(snapDisplay)

                        for(const loc of body.iwv[iwvMethod.key]){
                            const li = document.createElement('li')
                            list.appendChild(li)
                            li.classList.add('embla__slide')

                            const location = document.createElement('div')
                            li.appendChild(location)
                            location.classList.add('location')

                            location.innerHTML = `
                                <h3>${loc.location_name}</h3>
                                <p>${loc.address_line_1}</p>
                                ${loc.address_line_2 != null ? `<p>${loc.address_line_2}</p>` : ''}
                                <p>${loc.city}, ${loc.state_code} ${loc.zip}</p>
                                <p>${loc.dates_hours}</p>
                                `
                            // const map = document.createElement('div')
                            // li.appendChild(map)
                            // map.classList.add('map')

                            // map.innerHTML = `<gmpx-api-loader key="AIzaSyBP83wrdeU5yEAAzQNavRCqCX8jtQErj9k"></gmpx-api-loader>`


                        }

                        method.appendChild(pollingLocation)

                        voteMethods.appendChild(method)
                    }
                }

                wrap.appendChild(howToVote)

                document.querySelectorAll('.embla').forEach((e,i)=>{

                    const emblaApi = EmblaCarousel(e.querySelector('.embla__viewport'), { loop: false })
                    const prev = e.querySelector('.embla__prev')
                    const next = e.querySelector('.embla__next')
                    const snapDisplay = e.querySelector('.embla__selected-snap-display')

                    prev.addEventListener('click', () => emblaApi.scrollPrev(), false)
                    next.addEventListener('click', () => emblaApi.scrollNext(), false)

                    const toggleButtonsDisabled = (emblaApi) => {
                        const setButtonState = (button, enabled) => {
                            button.toggleAttribute('disabled', !enabled)
                        }
                        setButtonState(prev, emblaApi.canScrollPrev())
                        setButtonState(next, emblaApi.canScrollNext())
                    }

                    toggleButtonsDisabled(emblaApi)
                    emblaApi.on('select', toggleButtonsDisabled)
                    emblaApi.on('reinit', toggleButtonsDisabled)
                    updateSelectedSnapDisplay(emblaApi, snapDisplay)
                    
                })

                tinytabs(document.querySelector(".tabs"), {});

                
            }

            const candidates = document.createElement('div')
            candidates.classList.add('section')
            wrap.appendChild(candidates)

            const candidatesTitle = document.createElement('h2')
            candidatesTitle.innerText = 'Who to Vote For'
            candidates.appendChild(candidatesTitle)

            const legend = document.createElement('ul')
            legend.classList.add('candidates')
            const legendSupport = document.createElement('li')
            legend.appendChild(legendSupport)
            legendSupport.classList.add('support')
            legendSupport.innerHTML = `<img src="${checkURL.toString()}" alt="Check mark" title="These Democrats are counting on your vote!" /><p>These Democrats are counting on your vote!</p>`

            // const legendOppose = document.createElement('li')
            // legend.appendChild(legendOppose)
            // legendOppose.classList.add('oppose')

            // legendOppose.innerHTML = `<img src="${warnURL.toString()}" alt="Warning" title="This candidate is pursuing an extremist political agenda." /><p>This candidate is pursuing an extremist political agenda.</p>`

            candidates.appendChild(legend)

            for (const race of body.candidates.sort((a, b) => a.office_order - b.office_order)) {
                console.log(race)
                const h3 = document.createElement('h3')
                h3.innerText = race.candidates[0].position
                const ul = document.createElement('ul')
                ul.classList.add('candidates')

                for (const candidate of race.candidates.sort((a, b) => a.candidate_order - b.candidate_order)) {
                    const li = document.createElement('li')
                    ul.appendChild(li)
                    li.classList.add(candidate.status)
                    li.innerHTML = `
                        ${candidate.status === 'support'
                            ? `<img src="${checkURL.toString()}" alt="Check mark" title="This Democrat is counting on your vote." />`
                            : candidate.status === 'oppose'
                                ? `<img src="${warnURL.toString()}" alt="Warning" title="This candidate is pursuing an extremist political agenda." />`: '<span class="spacer" aria-hidden="true"></span>'}
                        <p>${candidate.name}</p>`
                }

                candidates.appendChild(h3)
                candidates.appendChild(ul)
            }
        }

        wrap.setAttribute('aria-busy', 'true')

        wrap.scrollIntoView({ 
                behavior: "smooth", 
                block: "start", 
                inline: "nearest" 
                });
                
        const act = document.querySelector('.act')
        
        if(body.link){
            act.querySelector('.btn').setAttribute('href',body.link.link)
        }else{
            act.querySelector('.btn').setAttribute('href','https://azdems.org')
        }


        act.style.display = "block"
        
    // })
    return false
})
